<!-- 电影订单支付-->
<template>
    <div class="root-wrap">
        <div class="body-wrap fx-fill">
            <div class="fill-box">
                <div class="order_content-wrap">
                    <div class="order_content fx-row">
                        <div>
                            <van-image class="order_poster" :src="orderInfo.logo" fit="fill"></van-image>
                        </div>
                        <div class="fx-fill fx-column fx-between">
                            <div class="order_content-title fx-row fx-center">
                                <div class="order_name">{{movieInfo['影片']}}</div>
                                <div style="margin-left: 2em;">{{orderInfo.quantity || '-'}}张</div>
                            </div>
                            <div>
                                <span>{{movieInfo['场次']}} </span>
                                <span v-if="movieInfo['版本']">({{movieInfo['版本']}})</span>
                            </div>
                            <div>{{movieInfo['影票']}}</div>
                            <div>{{movieInfo['影厅']}}</div>
                            <div>{{movieInfo['影院']}}</div>
                        </div>
                    </div>
                    <van-divider dashed :hairline="false" :style="{ color: $config.style.secondColor, margin: '10px 0'}"></van-divider>
                    <div class="order_tips fx-row fx-between">
                        <div class="fx-row fx-center">
                            <div>
                                <van-icon :name="require('@/assets/images/order/invalid.png')" size="10" style="margin-right: .4em;"></van-icon>
                                <span>不支持退票</span>
                            </div>
                            <div style="margin-left: 1.5em;">
                                <van-icon :name="require('@/assets/images/order/invalid.png')" size="10" style="margin-right: .4em;"></van-icon>
                                <span>不支持改签</span>
                            </div>
                        </div>
                        <div class="fx-row fx-center">
                            <van-icon :name="require('@/assets/images/order/time_out.png')" size="10" style="margin-right: .4em;"></van-icon>
                            <van-count-down ref="countDown" :time="payRemainingTime" :auto-start="false" format="mm:ss" style="font-size: 1em;" @finish="payTimeout"></van-count-down>
                            <!-- <span :class="payRemainingTime < 300 ? 'fc-active' : ''">{{payRemainingTime | formatSecondToMin}}</span> -->
                        </div>
                    </div>
                </div>
                <div class="order_phone-wrap" v-if="orderInfo.mobile">
                    <van-cell :title="orderInfo.mobile" label="购票成功后会收到短信通知" center>
                        <template #icon>
                            <van-image class="cell-icon" :src="require('@/assets/images/order/phone_ico.png')" fit="cover" width="36"></van-image>
                        </template>
                    </van-cell>
                </div>
                <div class="order_coupon-wrap">
                    <van-cell title="卡券" center is-link value-class="widen" @click="showCoupon = true">
                        <template #icon>
                            <van-image class="cell-icon" :src="require('@/assets/images/order/coupon.png')" fit="cover" width="36"></van-image>
                        </template>
                        <div>
                            <span>{{cardTotal}}张卡券</span>
                            <span class="fc-active">(已选{{selectedCouponList.length}}张)</span>
                        </div>
                    </van-cell>
                </div>
                <div v-if="orderInfo.vipcardbalance" class="order_vip-wrap">
                    <van-cell title="贵宾卡支付" center @click="changeVip">
                        <div style="padding-right: 10px;">
                            <span>余额：</span>
                            <span>{{orderInfo.vipcardbalance | formatIntToMoney}}片</span>
                        </div>
                        <template #icon>
                            <van-image class="cell-icon" :src="require('@/assets/images/order/vipCard.png')" fit="cover" width="36"></van-image>
                        </template>
                        <template #right-icon>
                            <van-image :src="useVip ? require('@/assets/images/order/selected.png') : require('@/assets/images/order/select.png')" fit="cover" width="15"></van-image>
                        </template>
                    </van-cell>
                </div>
                <div class="order_payway-wrap">
                    <van-radio-group v-model="payWay">
                        <van-cell-group>
                            <van-cell title="微信" center @click="payWay = 'wx'">
                                <template #icon>
                                    <van-image class="cell-icon" :src="require('@/assets/images/order/wechat_pay.png')" fit="cover" width="36"></van-image>
                                </template>
                                <template #right-icon>
                                    <van-radio name="wx">
                                        <template #icon="props">
                                            <!-- 使用show 比if渲染更快 show:display:none-->
                                            <van-image v-show="props.checked" :src="require('@/assets/images/order/selected.png')" fit="cover" width="15"></van-image>
                                            <van-image v-show="!props.checked" :src="require('@/assets/images/order/select.png')" fit="cover" width="15"></van-image>
                                        </template>
                                    </van-radio>
                                </template>
                            </van-cell>
                            <van-cell v-if="false" title="支付宝" center @click="payWay = 'zfb'">
                                <template #icon>
                                    <van-image class="cell-icon" :src="require('@/assets/images/order/ali_pay.png')" fit="cover" width="36"></van-image>
                                </template>
                                <template #right-icon>
                                    <van-radio name="zfb">
                                        <template #icon="props">
                                            <van-image v-show="props.checked" :src="require('@/assets/images/order/selected.png')" fit="cover" width="15"></van-image>
                                            <van-image v-show="!props.checked" :src="require('@/assets/images/order/select.png')" fit="cover" width="15"></van-image>
                                        </template>
                                    </van-radio>
                                </template>
                            </van-cell>
                        </van-cell-group>
                    </van-radio-group>
                </div>
                <div class="order_instructions-wrap">
                    <div class="fs-14">购票须知</div>
                    <div>
                        <p>
                            1.请确认场次和时间无误，购买成功后将不予退换
                            <br />2.由于设备故障等不可抗因素，存在少量场次锁座失败情况
                            <br />3.平均10-30分钟出票，超过30分钟未出票请联系客服
                            <br />4.出票成功后，将以短信通知提醒您，可到影院取票机取票
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer-wrap fx-row fx-between fx-center">
            <div class="order_amount fx-column">
                <div>
                    <span class="fc-active fw-7">总计￥</span>
                    <span class="fc-active fw-7"> {{orderInfo.amount}}</span>
                </div>
                <div v-if="orderInfo.amount != orderInfo.originalamount">
                    <span class="fc-tips" style="font-size: 10px;">已优惠￥</span>
                    <span class="fc-tips" style="font-size: 10px;"> {{orderInfo.originalamount - orderInfo.amount}}</span>
                </div>
            </div>
            <div class="order_confirm">
                <van-button :color="$config.style.primaryColor" size="small" @click="test" round style="padding: 2px 30px;">确认支付</van-button>
            </div>
        </div>
        <div class="utils-wrap">
            <van-popup v-model="showCoupon" round position="bottom" class="fx-column" style="height: 80%;padding-top: 4px;" @click-overlay="cancelSelectCoupon" :closeable="true" close-icon="close">
                <order-coupon-popup v-model="selectedCouponListTemp" :coupon-list="couponList" :un-used-coupon-list="unUsedCouponList" :exchange-card-list="exchangeCardList" :un-used-exchange-card-list="unUsedExchangeCardList" :max-selected="orderInfo.quantity" @confirm="doSelectCoupon" @refresh="getCouponInfo"></order-coupon-popup>
            </van-popup>
            <ali-pay-form :form-data="formData" :form-action="formAction"></ali-pay-form>
            <van-overlay :show="showPayStatus" :z-index="99" class-name="fx-center-middle">
                <div style="border-radius: 4px;background-color: #fff;width: 70%;">
                    <h3 class="fx-center" style="padding: 8px 0;">请确认支付是否已完成</h3>
                    <van-button block class="fc-active" @click="confirmPay">已完成支付</van-button>
                    <van-button block class='fc-tips' @click="showPayStatus = false">支付遇到问题，重新支付</van-button>
                </div>
            </van-overlay>
        </div>
    </div>
</template>

<script>
import { wxPaymentV2 } from '@/libs/wx-utils';
import { mapGetters } from 'vuex';
import AliPayForm from '@/components/order/ali-pay-form';
import OrderCouponPopup from '@/components/order/order-coupon-popup';
export default {
    data() {
        let radioIcons = [require('@/assets/images/order/select.png'), require('@/assets/images/order/selected.png')];
        return {
            radioIcons,
            tradeNo: this.$route.query.tradeNo,
            orderInfo: {},
            movieInfo: {},
            payRemainingTime: 0,
            showCoupon: false,
            couponList: [],
            unUsedCouponList: [],
            exchangeCardList: [],
            unUsedExchangeCardList: [],
            selectedCouponListTemp: [], //临时选中优惠券集合
            selectedCouponList: [], //实际选中优惠券集合
            payWay: null,
            useVip: false,
            formData: {},
            formAction: '',
            aliPayWebView: 'http://wx.dumovie.com/payfromwx/',
            showPayStatus: false,
        }
    },
    computed: {
        ...mapGetters([
            'selectedSeatList',
            'openId',
            'platform',
        ]),
        selectedCouponTempNos() {
            let couponNoList = this.selectedCouponListTemp.map((item) => {
                return item;
            });
            return couponNoList.join(',');
        },
        cardTotal() {
            return this.couponList.length + this.exchangeCardList.length;
        },
        payMethod() {
            if (this.orderInfo.amount == 0 && this.selectedCouponList.length > 0) {
                //只有使用了优惠券完全抵扣 才是0元支付
                return 'zeroPay';
            }

            if (this.orderInfo.amount && !this.payWay) return void (0);
            let payMethod = '';
            payMethod += this.useVip ? 'vipPay,' : '';
            payMethod += this.payWay == 'zfb' ? 'aliWapPay' : '';
            payMethod += this.payWay == 'wx' ? (this.platform == 'wx' ? 'wxjspay' : 'wxwappay') : '';
            return payMethod;
        },
    },
    methods: {
        //获取订单信息
        getOrderInfo() {
            return new Promise((resolve, reject) => {
                this.$service.getOrder({ tradeno: this.tradeNo }).then((res) => {
                    let order = res.order;
                    this.orderInfo = order;
                    if (order.ordertype == 'M') {
                        this.movieInfo = JSON.parse(order.description);
                    }
                    resolve(res);
                }).catch((error) => {
                    reject(error);
                });
            })
        },
        //获取优惠券信息
        getCouponInfo() {
            return new Promise((resolve, reject) => {
                this.$service.getMemberOrderCouponList({ tradeno: this.tradeNo }).then((res) => {
                    this.couponList = this.filterCouponList(res.couponlist, item => item.type === 'A');
                    this.unUsedCouponList = this.filterCouponList(res.unusedcouponlist, item => item.type === 'A');
                    this.exchangeCardList = this.filterCouponList(res.couponlist, item => item.type === 'D');
                    this.unUsedExchangeCardList = this.filterCouponList(res.unusedcouponlist, item => item.type === 'D');
                    resolve(res);
                }).catch((error) => {
                    reject(error);
                });
            })
        },
        filterCouponList(list, callback) {
            if (!list || list.length < 1) return [];
            return list.filter(callback);
        },
        //获取订单剩余支付时间
        getOrderRemainingPayTime() {
            this.$service.getOrderRemaining({ tradeno: this.tradeNo }).then((res) => {
                this.payRemainingTime = res.remaining * 1000;
                setTimeout(() => {
                    this.$refs.countDown.start();
                })
            });
        },
        toggleCoupon(index) {
            this.$refs.checkboxes[index].toggle();
        },
        //确认选择优惠券
        doSelectCoupon() {
            this.showCoupon = false;
            if (this.orderInfo.quantity < this.selectedCouponListTemp.length) {
                this.$toast('使用卡券的数量不能超过座位数');
                this.selectedCouponListTemp = Object.assign([], this.selectedCouponList);
                return false;
            }
            this.modifySelectedCoupon().then(() => {
                this.selectedCouponList = Object.assign([], this.selectedCouponListTemp);
                //后端更新优惠券使用状态 前端刷新订单
                this.getOrderInfo().then(() => {
                    this.checkAmountToResolvePayWay();
                });
            }).catch((error) => {
                console.log(error)
                this.selectedCouponListTemp = Object.assign([], this.selectedCouponList);
            });
        },
        //点击优惠券遮罩层关闭 则取消选择
        cancelSelectCoupon() {
            this.selectedCouponListTemp = Object.assign([], this.selectedCouponList);
        },
        //更改选中优惠券信息
        modifySelectedCoupon() {
            return new Promise((resolve, reject) => {
                let params = {
                    tradeno: this.tradeNo,
                    cardnos: this.selectedCouponTempNos,
                }
                this.$service.modifyCouponByOrder(params).then((res) => {
                    resolve();
                }).catch((err) => {
                    reject(err);
                })
            })
        },
        //手动选择或初始化赋值是否使用贵宾卡, value存在时表示已经绑定过订单贵宾卡支付 直接选中
        changeVip(value) {
            if (value === true) {
                this.useVip = true;
                return;
            }
            if (this.selectedCouponList.length > 0) {
                this.$toast('优惠不可与贵宾卡同享');
                return;
            }
            if (!this.orderInfo.vipcardbalance) {
                this.$toast('暂无可用余额');
                return;
            }
            let _useVip = !this.useVip;
            this.modifyUseVip(_useVip).then(() => {
                this.useVip = _useVip;
            });
        },
        //更改使用贵宾卡支付
        modifyUseVip(_useVip) {
            return new Promise((resolve, reject) => {
                let params = {
                    usestatus: _useVip ? 'Y' : 'N',
                    tradeno: this.tradeNo
                }
                this.$service.modifyUseVip(params).then((res) => {
                    this.getOrderInfo().then(() => {
                        resolve();
                    });
                }).catch(() => {
                    reject();
                });
            })
        },
        //检查订单金额决定支付方式 0元则无需wx zfb支付
        checkAmountToResolvePayWay() {
            if (this.orderInfo) {
                if (this.orderInfo.amount) {
                    this.payWay ? '' : this.payWay = 'wx';
                } else {
                    this.payWay = null;
                }
            }
        },
        test() {
            // console.log(JSON.stringify(this.selectedCouponListTemp));
            // return;
            this.beforePay();
        },
        beforePay() {
            if (this.payMethod) {
                this.$dialog.confirm({
                    title: '系统提示',
                    message: '确认支付订单?'
                }).then(() => {
                    let loading = this.$toast.loading(this.$config.loadingMsg);
                    this.doPayment().then((res) => {
                        loading.clear();
                        console.log(this.payMethod);
                        if (!this.payWay) {
                            //这里属于0元支付
                            this.$goPage('order-pay-done', {
                                tradeNo: this.tradeNo
                            }, true);
                        }
                        if (this.platform == 'wx') {
                            if (this.payWay == 'zfb') {
                                //微信内置浏览器中支付宝支付跳转
                                let href = this.aliPayWebView + this.tradeNo;
                                window.location.href = href;
                            } else if (this.payWay == 'wx') {
                                //微信内置浏览器中微信支付
                                //TODO 支付成功
                                wxPaymentV2(res, () => {
                                    this.$goPage('order-pay-done', {
                                        tradeNo: this.tradeNo
                                    }, true);
                                });
                            }
                        } else {
                            if (this.payWay == 'zfb') {
                                //其他浏览器中支付使用表单提交至支付宝
                                let formData = Object.assign({}, res);
                                this.formAction = res.payurl;
                                this.formData = formData;
                                setTimeout(
                                    "document.aliPayForm.submit()",
                                    800
                                );
                            } else if (this.payWay == 'wx') {
                                //其他浏览器中使用微信支付 跳转
                                console.log(res.payurl);
                                setTimeout(() => {
                                    this.showPayStatus = true;
                                    document.location.href = res.payurl;
                                }, 0);
                            }
                        }

                    });
                });
            } else {
                this.$toast('请选择支付方式');
                return false;
            }
        },
        doPayment() {
            return new Promise((resolve, reject) => {
                let params = {
                    paymethod: this.payMethod,
                    tradeno: this.tradeNo,
                    openid: this.openId,
                }
                this.$service.doOrderPay(params).then((res) => {
                    resolve(res);
                }).catch(() => {
                    reject();
                })
            })
        },
        confirmPay() {
            this.showPayStatus = false;
            this.$goPage('order-pay-done', {
                tradeNo: this.tradeNo,
            }, true);
        },
        payTimeout() {
            this.$toast.allowMultiple();
            let timeout = this.$toast('订单支付已超时');
            console.log('订单支付超时,返回订单页');
            setTimeout(() => {
                this.$goPage('user-order', null, true);
            }, 0)
        },
        initPage() {
            this.getOrderRemainingPayTime();
            Promise.all([this.getOrderInfo(), this.getCouponInfo()]).then((result) => {
                let cards = this.orderInfo.items;
                if (this.orderInfo.vipuseamount) {
                    this.changeVip(true);
                } else {
                    if (cards && cards.length > 0) {
                        cards.forEach((item) => {
                            if (item.itemtype != 'N') {
                                let tempResult = this.couponList.filter((coupon) => coupon.cardno == item.cardno)
                                    .concat(this.exchangeCardList.filter((card) => card.cardno == item.cardno));
                                if (tempResult.length > 0) {
                                    this.selectedCouponListTemp.push(item.cardno);
                                }

                            }
                        });
                        this.selectedCouponList = Object.assign([], this.selectedCouponListTemp);
                        this.checkAmountToResolvePayWay();
                    }
                }

            })
        },
    },
    watch: {
        'selectedCouponList': {
            immediate: true,
            handler(val) {
                if (val.length > 0) {
                    this.useVip = false;
                }
            }
        },
        'useVip': {
            handler(val) {
                if (val) {
                    this.checkAmountToResolvePayWay();
                }
            }
        },
        'payWay': {
            handler(val) {
                console.log(val);
                console.log(this.useVip);
                if (val) {
                    this.checkAmountToResolvePayWay();
                }
            }
        }
    },
    mounted() {
        this.initPage();
    },
    // beforeRouteLeave(to, from, next) {
    //     console.log(123)
    //     this.$dialog.confirm({
    //         title: '系统提示',
    //         message: '确认返回吗?'
    //     }).then(() => {
    //         next();
    //     });
    //     return false;
    // },
    filters: {
        getTicketLength(val) {
            return val ? val.split(',').length : 0;
        }
    },
    components: {
        AliPayForm,
        OrderCouponPopup
    },
    metaInfo: {
        meta: [
            { name: 'referrer', content: 'always' }
        ]
    },
}
</script>

<style lang="scss" scoped>
.body-wrap {
	position: relative;
	.fill-box {
		padding: 0 12px;
		> div {
			margin: 10px 0;
			border-radius: 8px;
			background-color: #fff;
			&.order_content-wrap {
				padding: 15px;
				.order_content {
					> div:first-child {
						margin-right: 15px;
					}
					.order_poster {
						border-radius: 4px;
						overflow: hidden;
						width: 90px;
						height: 125px;
					}
					.order_name {
						font-size: 16px;
						// font-family: "pf medium";
					}
				}
			}
			.cell-icon {
				margin-right: 15px;
			}
			&.order_instructions-wrap {
				padding: 15px;
			}
		}
	}
}

.widen {
	min-width: 58%;
}
.widen70 {
	min-width: 70%;
}

.utils-wrap {
	/deep/ .van-popup__close-icon {
		top: 8px;
		right: 15px;
		font-size: 18px;
		color: $main-color;
	}
	/deep/ .van-cell__value {
		padding-right: 18px;
	}
	/deep/ .checkbox_icon {
		position: absolute;
		top: 0;
		right: 0;
		width: 32px;
		height: 32px;
		border: 1px solid red;
		background-color: #e42f46;
		border-top-right-radius: 8px;
		border-bottom-left-radius: 40px;
	}
}

.footer-wrap {
	padding: 15px 30px;
	background-color: #fff;
	.order_amount {
		font-size: 16px;
		> span:nth-child(2) {
			font-size: 18px;
		}
	}
}
</style>
